// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Element from 'element-ui'

import MintUI from 'mint-ui'
import './assets/style/index.css'
import 'mint-ui/lib/style.css'
import './assets/iconfonts/iconfont.css'
import 'element-ui/lib/theme-chalk/index.css'
import VueParticles from 'vue-particles'
import DictSelect from '@/components/DictSelect'
import {formatName} from "@/utils";
//main.js中引入：
import vueEsign from 'vue-esign'
Vue.use(vueEsign)
Vue.use(VueParticles)
// import iView from 'iview';
// import 'iview/dist/styles/iview.css';    // 使用 CSS
Vue.use(Element, {
  size: 'mini', // set element-ui default size
})
Vue.use(MintUI)
Vue.prototype.$formatName = formatName
Vue.component('DictSelect', DictSelect)
Vue.config.productionTip = false
// console.log('main.js', new Date())

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js